import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { style: {"padding":"20px"} }
const _hoisted_2 = {
  key: 0,
  class: "content_container"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "已登录", -1)
const _hoisted_4 = {
  key: 0,
  class: "content_container"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode("刷新状态")
const _hoisted_7 = {
  key: 1,
  class: "content_container"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("立即登录")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_unicon = _resolveComponent("unicon")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLogin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_unicon, {
            name: "check-circle",
            width: "150",
            height: "150",
            fill: "limegreen"
          }),
          _hoisted_3
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.qrcodeUrl?.length>0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: _ctx.qrcodeUrl,
                  style: {"width":"160px","height":"160px","margin":"20px"}
                }, null, 8, _hoisted_5),
                _createVNode(_component_el_button, {
                  onClick: _ctx.checkLogin,
                  round: "",
                  type: "primary",
                  style: {"width":"100px"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_unicon, {
                  name: "info-circle",
                  width: "150",
                  height: "150",
                  fill: "limegreen"
                }),
                _createVNode(_component_el_button, {
                  onClick: _ctx.login,
                  round: "",
                  type: "primary",
                  style: {"width":"100px"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
        ], 64))
  ]))
}